export const DEFAULT_LOAD_PLACES_SUGGESTIONS_DELAY = 1500;
export const DEFAULT_LOAD_SUGGESTIONS_DELAY = 300;
